// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.display-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  margin-top: 10px;
}
.image-preview {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border: 1px solid #ddd;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ManageProgram/Display.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":[".display-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  margin-top: 10px;\n}\n.image-preview {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
